/**
 * 判断是否为编辑器
 */
function isEditor() {
    return !!window.FEGOEditor;
}

function getPageDebuggerParams() {
    if (window.FEGOEditor) {
        return null;
    }

    const { pageDebugger } = window.FEGORender.plugins || {};
    if (pageDebugger && pageDebugger.params) {
        return pageDebugger.params;
    }
    return null;
}

// 获取插件配置（只有表单，只能通过这种方式获取）
function getPluginConfig(name) {
    return window?._extra?.[name] || {};
}

export { isEditor, getPageDebuggerParams, getPluginConfig };
